var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1881 0.979866C16.1881 0.422193 15.7452 -0.0332032 15.2005 0.00190261C13.4781 0.11291 11.7831 0.513722 10.1845 1.19031C8.28115 1.99589 6.55171 3.17664 5.09494 4.66516C3.63816 6.15367 2.48259 7.92079 1.69418 9.86563C0.905784 11.8105 0.5 13.8949 0.5 16C0.5 18.1051 0.905785 20.1895 1.69419 22.1344C2.48259 24.0792 3.63816 25.8463 5.09494 27.3348C6.55171 28.8234 8.28116 30.0041 10.1845 30.8097C11.7831 31.4863 13.4781 31.8871 15.2005 31.9981C15.7452 32.0332 16.1881 31.5778 16.1881 31.0201L16.1881 0.979866Z",
    fill: "url(#paint0_linear_322_4790)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5882 4.26159C24.5882 3.70392 24.1449 3.24751 23.601 3.29341C20.719 3.5366 18.0004 4.83869 15.9408 6.98569C13.6473 9.37644 12.3589 12.619 12.3589 16C12.3589 19.381 13.6473 22.6236 15.9408 25.0143C18.0004 27.1613 20.719 28.4634 23.601 28.7066C24.1449 28.7525 24.5882 28.2961 24.5882 27.7384V4.26159Z",
    fill: "url(#paint1_linear_322_4790)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_322_4790",
    x1: 0.30976,
    y1: 35.3987,
    x2: 25.6221,
    y2: -3.54155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0194FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FF8D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_322_4790",
    x1: 12.2106,
    y1: 31.4096,
    x2: 32.4692,
    y2: 0.825992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0194FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FF8D1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.02f591edac82d2cf157a3afbac97c19f.svg";
export { ForwardRef as ReactComponent };